import { createStore, applyMiddleware, compose } from 'redux';
import { combineReducers } from 'redux-immutable';
import createThunk from 'javascripts/util/thunk';
import { reducers, initialState } from './reducers';

let composeEnhancers;
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: 'Timeline Control',
  });
} else {
  composeEnhancers = compose;
}

export default () =>
  createStore(
    combineReducers(reducers),
    initialState,
    composeEnhancers(applyMiddleware(createThunk()))
  );
